
import { accessJsonAttr } from '../../utils/utils';
import { MgpRadioProps } from './MgpRadio.types';


export default function MgpFormRadio({id, label, register, errors = {},  ...props }: MgpRadioProps)  {

    let selectClassName = "form flex va-center jc-left";
    let labelClassName = "switch";
    let fieldError;
    if(errors) {
        fieldError = accessJsonAttr(errors, id);
        if(fieldError) {
          selectClassName += " form-error";
          labelClassName += " form-error";
        }
    }

    return (
       
            <div className={selectClassName} style={{gap: "20px"}}>
                <h3 className="fw-bold fz-normal m-y-md">{label}</h3>
                <label className="switch">
                    <input type="radio" {...register(id)} {...props}/>
                    <span className="slider"></span>
                </label>
            </div>
      
  )
}
